import React, { useContext } from 'react'
import './Nav.sass'
import { Link, withRouter } from 'react-router-dom'
import Icon from '../../../ui/Icon/Icon'
import { firebase } from '../../../config/firebase'
import { AuthContext } from '../../../App'
import { isMarketingOnlyUser } from '../../../config/accessControl'
import { isCustomersListAllowedUser } from '../../../config/customersAccessControl'
import { canAccessBlog } from '../../../config/blogAccessControl'

function Nav({ location }) {
  const { user } = useContext(AuthContext)
  const marketingOnly = isMarketingOnlyUser(user?.uid)
  const showBlog = canAccessBlog(user)

  return (
    <div className="Nav">
      <div className="NavBody">
        {!marketingOnly && (
          <>
            <NavElement title="Каталог" icon="list" link="/products/category-tree" location={location} />
            <NavElement title="Замовл." icon="box" link="/orders/list" location={location} />
            {isCustomersListAllowedUser(user?.uid) && (
              <NavElement title="Клієнти" icon="users" link="/customers" location={location} />
            )}
          </>
        )}
        <NavElement title="Маркетинг" icon="megaphone" link="/marketing/list" location={location} />
        {showBlog ? <NavElement title="Блог" icon="pen" link="/blog" location={location} /> : null}
        {!marketingOnly && <NavElement title="Сайт" icon="cog" link="/settings/banners" location={location} />}
      </div>

      <NavElement title="Вихід" icon="sign-out-alt" onClick={() => firebase.auth().signOut()} location={location} />
    </div>
  )
}

function NavElement({ title, icon, link, onClick, location }) {
  const content = (
    <>
      <div className="NavElement-Icon">
        <Icon name={icon} />
      </div>
      <p className="Title">{title}</p>
    </>
  )

  const sectionPath = getSectionPath(link)
  const isActive = Boolean(link && sectionPath && location.pathname.startsWith(sectionPath))

  return onClick ? (
    <div className="NavElement" onClick={onClick}>
      {content}
    </div>
  ) : (
    <Link to={link} className={`NavElement ${isActive ? 'NavElement-Active' : ''}`.trim()}>
      {content}
    </Link>
  )
}

const getSectionPath = (link = '') => {
  const [, section] = `${link}`.split('/')
  return section ? `/${section}` : ''
}

export default withRouter(Nav)
